import Vue from "vue";

const errorHandler = error => {
    Vue.prototype.$eventHub.$emit("profile.error", error);
};

const actions = {
    async operatorBuhgalterFetchAccounts({ commit }, id) {
        commit("setAccountsLoading")
        commit("setError", null)

        try {
            const {data: { data }} = await axios.get(`/operator-buhgalter/profiles/${id}/accounts`)
            commit("setAccounts", data)
        } catch (error) {
            console.error(error)
            commit("setError", error.response.data.message);
        }
        commit("setAccountsLoading", false)
    },
    async operatorBuhgalterRefillAccount({ commit }, { id, sum, comment, refillFrom, refillDebt }) {
        commit("setAccountsLoading")
        try {
            const {data: { data }}  = await axios.post(`/operator-buhgalter/profiles/${id}/accounts/refill`, {
                summ: sum,
                comment: comment,
                refillFrom: refillFrom,
                refillDebt: refillDebt
            })
            commit("setAccounts", data)
        } catch (error) {
            console.error(error)
            throw error
        }
        commit("setAccountsLoading", false)
    },
    async operatorBuhgalterWithdrawAccount({ commit }, { id, sum, comment, withdrawFrom }) {
        commit("setAccountsLoading")
        try {
            const {data: { data }}  = await axios.post(`/operator-buhgalter/profiles/${id}/accounts/withdraw`, {
                summ: sum,
                comment: comment,
                withdrawFrom: withdrawFrom,
            })
            commit("setAccounts", data)
        } catch (error) {
            console.error(error)
            throw error
        }
        commit("setAccountsLoading", false)
    },
};

export default actions;
